import { AxiosResponse } from 'axios';

export function noContentInterceptor(response: AxiosResponse) {
  if (response?.status === 204) {
    response.data = null;
  }
  return response;
}
